import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import store from "./lib/redux/Store";
import { Provider } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import Home from './views/home';
import About from './views/about';
import Catalog from './views/catalog';



const App = () => {
  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {/* Default route */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/task/:id" element={<Home />} />
      </Routes>
    </Provider>
  );
};


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default App;
